import { getProgramParameters } from '../services/internal-register';
import Storage from '../services/storage';

export default (to, from, next) => {
  getProgramParameters(to.params.programId)
    .then(response => {
      Storage.set('program', response.data);

      next();
    })
    .catch(error => {
      const { message } = error;

      Storage.set('error_message', message);

      return next({
        name: 'generic-error'
      });
    });
};
